/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsDigitizingColorListItem
 */
export interface DigitizingMelcoDigitizingModelsDigitizingColorListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingColorListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingColorListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingColorListItem
     */
    hex_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingColorListItem
     */
    sort_order?: number;
}

export function DigitizingMelcoDigitizingModelsDigitizingColorListItemFromJSON(json: any): DigitizingMelcoDigitizingModelsDigitizingColorListItem {
    return DigitizingMelcoDigitizingModelsDigitizingColorListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsDigitizingColorListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsDigitizingColorListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'hex_code': !exists(json, 'hex_code') ? undefined : json['hex_code'],
        'sort_order': !exists(json, 'sort_order') ? undefined : json['sort_order'],
    };
}

export function DigitizingMelcoDigitizingModelsDigitizingColorListItemToJSON(value?: DigitizingMelcoDigitizingModelsDigitizingColorListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'hex_code': value.hex_code,
        'sort_order': value.sort_order,
    };
}


